module.exports = "<ng-snotify></ng-snotify>\r\n<router-outlet></router-outlet>\r\n\r\n"